import clientService from '@services/client';

import { ITEM_DROPDOWN_NONE_VALUE_FEMININE } from '@admin/utils/DropdownItems';

export const getRetailersOfClientSuccess = (retailers) => ({
  type: 'CLIENT_RETAILERS_SUCCESS',
  retailers: [ITEM_DROPDOWN_NONE_VALUE_FEMININE(), ...retailers],
});

export const getRetailersClientError = (error) => ({
  type: 'CLIENT_RETAILERS_FAILURE',
  error,
});

export const getRetailersOfClient = () => (dispatch) => {
  dispatch({
    type: 'CLIENT_RETAILERS_REQUEST',
  });
  return clientService.getRetailersOfClient();
};
